export const UNIT_TABLE = "units"
export const UNIT_TABLE_SCHEMA = "id, companyId, abbreviation, syncId"
